import { render, staticRenderFns } from "./tplManager.vue?vue&type=template&id=35365883&scoped=true"
import script from "./tplManager.vue?vue&type=script&lang=js"
export * from "./tplManager.vue?vue&type=script&lang=js"
import style0 from "./tplManager.vue?vue&type=style&index=0&id=35365883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35365883",
  null
  
)

export default component.exports